/* Editorial US suggestions; catalog aliases are not search-volume claims. */
(() => {
  const suggestions = [
  [
    "Car wash soap",
    "car shampoo"
  ],
  [
    "Foam cannon",
    "foam cannon"
  ],
  [
    "Tire shine",
    "tyre guard"
  ],
  [
    "Ceramic coating",
    "ceramic coating"
  ],
  [
    "Water spot remover",
    "water spot remover"
  ],
  [
    "Aluminum cleaner",
    "alubright"
  ],
  [
    "Wheel cleaner",
    "wheel cleaner"
  ],
  [
    "Tire dressing",
    "tyre dressing"
  ],
  [
    "Microfiber towels",
    "microfiber towel"
  ],
  [
    "Drying towel",
    "drying towel"
  ],
  [
    "Wash mitt",
    "wash mitt"
  ],
  [
    "Glass cleaner",
    "glass cleaner"
  ],
  [
    "Interior cleaner",
    "interior cleaner"
  ],
  [
    "Leather cleaner",
    "leather cleaner"
  ],
  [
    "Leather conditioner",
    "leather conditioner"
  ],
  [
    "Car wax",
    "car wax"
  ],
  [
    "Spray wax",
    "spray wax"
  ],
  [
    "Graphene coating",
    "graphene coating"
  ],
  [
    "Clay bar",
    "clay bar"
  ],
  [
    "Iron remover",
    "iron remover"
  ],
  [
    "Upholstery cleaner",
    "upholstery cleaner"
  ],
  [
    "Trim restorer",
    "trim restorer"
  ],
  [
    "Quick detailer",
    "detail spray"
  ],
  [
    "Rinseless wash",
    "rinseless wash"
  ],
  [
    "Waterless wash",
    "waterless wash"
  ],
  [
    "Foam sprayer",
    "foam sprayer"
  ],
  [
    "Detailing brushes",
    "detailing brushes"
  ],
  [
    "Polishing pads",
    "polishing pad"
  ],
  [
    "Polishing compound",
    "polishing compound"
  ],
  [
    "Windshield washer fluid",
    "windshield washer fluid"
  ],
  [
    "Paint sealant",
    "paint sealant"
  ]
];
  const aliases = new Map(suggestions.map(([phrase, query]) => [phrase.toLowerCase(), query]));
  aliases.set('aluminium cleaner', 'alubright');
  aliases.set('tyre shine', 'tyre guard');
  const normalizeQuery = (value) => {
    const query = String(value || '').trim().replace(/\s+/g, ' ');
    return aliases.get(query.toLowerCase()) || query.replace(/\btires?\b/gi, 'tyre').replace(/\baluminum\b/gi, 'aluminium');
  };
  if (customElements.get('wavex-header-search')) return;
  customElements.define('wavex-header-search', class WavexHeaderSearch extends HTMLElement {
    connectedCallback() {
      if (this.cleanups) return;
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[name="q"]');
      this.overlay = this.querySelector('.wavex-wide-search__suggestion');
      this.phrase = this.querySelector('[data-search-phrase]');
      if (!this.form || !this.input || !this.overlay || !this.phrase) return;
      this.cleanups = [];
      this.timer = null;
      this.index = 0;
      this.position = suggestions[0][0].length;
      this.erasing = true;
      this.media = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.listen = (target, type, callback) => {
        target.addEventListener(type, callback);
        this.cleanups.push(() => target.removeEventListener(type, callback));
      };
      this.stop = () => { window.clearTimeout(this.timer); this.timer = null; };
      this.canAnimate = () => this.isConnected && !document.hidden && !this.media.matches && document.activeElement !== this.input && !this.input.value;
      this.schedule = (delay) => {
        this.stop();
        if (this.canAnimate()) this.timer = window.setTimeout(this.tick, delay);
      };
      this.tick = () => {
        this.timer = null;
        if (!this.canAnimate()) return;
        const text = suggestions[this.index][0];
        this.position += this.erasing ? -1 : 1;
        this.phrase.textContent = text.slice(0, this.position);
        if (!this.erasing && this.position >= text.length) {
          this.erasing = true;
          this.schedule(2200);
        } else if (this.erasing && this.position <= 0) {
          this.index = (this.index + 1) % suggestions.length;
          this.erasing = false;
          this.schedule(280);
        } else this.schedule(this.erasing ? 34 : 74);
      };
      this.refresh = () => {
        this.stop();
        this.overlay.hidden = Boolean(this.input.value) || document.activeElement === this.input;
        this.toggleAttribute('data-static', this.media.matches);
        if (this.media.matches) {
          this.index = 0;
          this.position = suggestions[0][0].length;
          this.erasing = true;
          this.phrase.textContent = suggestions[0][0];
        }
        this.schedule(2200);
      };
      // Native form submission fires formdata after constructing its entry list.
      // Rewrite only the outgoing query. The shopper's visible input is untouched.
      this.listen(this.form, 'formdata', (event) => {
        event.formData.set('q', normalizeQuery(event.formData.get('q')));
        event.formData.set('type', 'product');
      });
      // Older browsers without formdata retain the native action/method and GET
      // serialization by temporarily assigning q to an invisible successful control.
      if (!('FormDataEvent' in window)) {
        this.listen(this.form, 'submit', (event) => {
          if (event.defaultPrevented) return;
          this.restoreFallback?.();
          const proxy = document.createElement('input');
          proxy.type = 'hidden';
          proxy.name = 'q';
          proxy.value = normalizeQuery(this.input.value);
          const originalName = this.input.name;
          this.input.removeAttribute('name');
          this.form.appendChild(proxy);
          this.restoreFallback = () => {
            window.clearTimeout(this.fallbackTimer);
            this.input.name = originalName;
            proxy.remove();
            this.restoreFallback = null;
          };
          this.fallbackTimer = window.setTimeout(() => this.restoreFallback?.(), 0);
        });
      }
      this.listen(this.input, 'focus', this.refresh);
      this.listen(this.input, 'blur', this.refresh);
      this.listen(this.input, 'input', this.refresh);
      this.listen(this.input, 'change', this.refresh);
      this.listen(document, 'visibilitychange', this.refresh);
      this.listen(window, 'pageshow', () => { this.restoreFallback?.(); this.refresh(); });
      this.listen(this.form, 'reset', () => {
        window.clearTimeout(this.resetTimer);
        this.resetTimer = window.setTimeout(this.refresh, 0);
      });
      if (this.media.addEventListener) this.listen(this.media, 'change', this.refresh);
      else {
        this.media.addListener(this.refresh);
        this.cleanups.push(() => this.media.removeListener(this.refresh));
      }
      this.setAttribute('data-enhanced', '');
      this.phrase.textContent = suggestions[0][0];
      this.refresh();
    }
    disconnectedCallback() {
      this.stop?.();
      this.restoreFallback?.();
      window.clearTimeout(this.resetTimer);
      this.cleanups?.forEach((cleanup) => cleanup());
      this.cleanups = null;
      this.removeAttribute('data-enhanced');
      this.removeAttribute('data-static');
      if (this.overlay) this.overlay.hidden = true;
    }
  });
})();
